// extracted by mini-css-extract-plugin
module.exports = {"Box":"Box_Box__TYy1V"};